import CqrsClient from "./cqrsClient";

const cqrsClient = new CqrsClient({ baseUri: "/umbraco/api/Store/" });
const changeCallbacks = [];

export default {
    getCart: function () {
        return cqrsClient.query({
            $type: "SkoltHolding.Core.Models.Queries.GetCartQuery, SkoltHolding.Core",
        });
    },
    addCartItem: function (productId, quantity) {
        return cqrsClient.command({
            $type: "SkoltHolding.Core.Models.Commands.AddCartItemCommand, SkoltHolding.Core",
            productReference: productId,
            quantity: quantity
        }).then(c => {
            this.cartUpdated();
            return c
        });
    },
    updateCartItem: function (itemId, quantity) {
        return cqrsClient.command({
            $type: "SkoltHolding.Core.Models.Commands.UpdateCartItemCommand, SkoltHolding.Core",
            id: itemId,
            quantity: quantity
        }).then(c => {
            this.cartUpdated();
            return c
        });
    },
    removeCartItem: function (itemId) {
        return cqrsClient.command({
            $type: "SkoltHolding.Core.Models.Commands.RemoveCartItemCommand, SkoltHolding.Core",
            id: itemId
        }).then(c => {
            this.cartUpdated();
            return c
        });
    },
    setShippingMethod: function (shippingMethod, zipCode, notes) {
        return cqrsClient.command({
            $type: "SkoltHolding.Core.Models.Commands.SetShippingMethodCommand, SkoltHolding.Core",
            shippingMethod: shippingMethod,
            zipCode: zipCode,
            notes: notes
        }).then(c => {
            this.cartUpdated();
            return c
        });
    },
    cartUpdated: function () {
        this.getCart().then(cart => {
            changeCallbacks.forEach(c => {
                c(cart);
            });
        });
    },
    onChange(callback) {
        changeCallbacks.push(callback);
    }
};